import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative text-sm md:text-base select-none cursor-pointer" }
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-center justify-between",
    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
  }, [
    _createElementVNode("span", {
      class: "flex justify-center items-center w-6 h-6 md:w-8 md:h-8 icon-chevron_sinistra cursor-pointer border border-next-dark-gray hover:bg-next-orange hover:text-white hover:border-next-orange",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)), ["prevent","stop"]))
    }),
    _createElementVNode("span", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.month.format('MMMM YYYY')) + " ", 1),
      _createElementVNode("input", {
        class: "absolute inset-0 invisible",
        ref: "input",
        type: "month",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dateChange && _ctx.dateChange(...args))),
        value: _ctx.Value
      }, null, 40, _hoisted_2)
    ]),
    _createElementVNode("span", {
      class: "flex justify-center items-center w-6 h-6 md:w-8 md:h-8 icon-chevron_destra cursor-pointer border border-next-dark-gray hover:bg-next-orange hover:text-white hover:border-next-orange",
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.forward && _ctx.forward(...args)), ["prevent","stop"]))
    })
  ]))
}